import { styled } from '../../stitches.config'

export default styled('div', {
  boxSizing: 'border-box',
  borderStyle: 'solid',
  borderWidth: 0,
})
